import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import LaboratorySection from '../../components/LaboratorySection/LaboratorySection';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/mc-dencia-photos/BothLogos1.png'
import e1 from "./../../images/Laboratory/Еquipment/e1.jpg";
import e2 from "./../../images/Laboratory/Еquipment/e2.jpg";
import e3 from "./../../images/Laboratory/Еquipment/e3.jpg";
import e4 from "./../../images/Laboratory/Еquipment/e4.jpg";
import e5 from "./../../images/Laboratory/Еquipment/e5.png";
import ImageGallery from "react-image-gallery";

import "react-image-gallery/styles/css/image-gallery.css";

const ServicePage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={'Клинична лаборатория'} pagesub={'Клинична лаборатория'} />
            <LaboratorySection hclass={"service_section_s2 s3 section-padding"} sliceEnd={6} showSectionTitle={false} AllServices={false} />
            {/* <Title text="Апаратура"></Title> */}
            <div className="container">
                <div className="row g-0">
                    <div className="service_content p-div-4">
                        <h3>Апаратура</h3>
                        <div className='lab-gallery'>
                            <ImageGallery
                                showFullscreenButton={false}
                                showPlayButton={false}
                                items={[
                                    { original: e5, thumbnail: e5, showFullscreenButton: false },
                                    { original: e1, thumbnail: e1, showFullscreenButton: false },
                                    { original: e2, thumbnail: e2, showFullscreenButton: false },
                                    { original: e3, thumbnail: e3, showFullscreenButton: false },
                                    { original: e4, thumbnail: e4, showFullscreenButton: false },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <CtafromSection hclass={'ctafrom_section'} />
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />

        </Fragment>
    )
};
export default ServicePage;
